import React from "react";
import { useQueryClient, useMutation } from "react-query";
import { saveDdiSettings } from "services/ddi.services";

export const useDdiSaveSettings = () => {
  const queryClient = useQueryClient();
  return useMutation((payload) => saveDdiSettings(payload), {
    onSuccess: (res) => {
      queryClient.invalidateQueries("ddiSettings");
    },
  });
};

export default useDdiSaveSettings;
